module.exports = __webpack_public_path__ + "static/media/stofferingen-08.0c8d742f.jpg";